export default "__VITE_ASSET__D$Bo6oya__"